import { Component, OnInit, ViewChild, HostListener, AfterViewInit, ChangeDetectorRef, Input, SimpleChanges, Output, EventEmitter,} from "@angular/core";
import { MdbTableDirective, MdbTablePaginationComponent, ModalDirective } from 'ng-uikit-pro-standard';
import { Router } from '@angular/router';
import { AuthService } from "src/app/services/backoffice/auth/auth.service";


@Component({
  selector: 'app-table-users-back',
  templateUrl: './table-users-back.component.html',
  styleUrls: ['./table-users-back.component.scss']
})
export class TableUsersBackComponent implements OnInit {

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;

  
  @Input() data: any;
  @Input() stateModal: boolean;
  // @Input() refreshTableZone: boolean;

  @Input() headElements: string[];
  @Input() headTable: string[];
  @Input() colspanLarge: number;

  @Output() reponseStateModal = new EventEmitter();
  @Output() reponseDeleteTable = new EventEmitter();
  @Output() reponseUpdateTable = new EventEmitter();

  // @Output() responseRefreshTableZone = new EventEmitter();

  // elements: any = [];
  // previous: any = [];
  // headElements = ['N°','Nombre', 'Apellido Paterno', 'Apellido Materno', 'Telefono', 'Run', 'Email' , 'Rol', 'Herramientas'];
  // headTable = ['name1', 'name2', 'email', 'rut', 'telephone'];
  // headTable = ['name1', 'last_name1', 'last_name2', 'telephone', 'rut', 'email' , 'role', 'tools'];
  // colspanLarge: number = 9;
  // elements: any = [
  //   {id: 1, first: 'Mark', last: 'Otto', handle: '@mdo'},
  //   {id: 2, first: 'Jacob', last: 'Thornton', handle: '@fat'},
  //   {id: 3, first: 'Larry', last: 'the Bird', handle: '@twitter'},
  // ];
  elements: any = [];
  // headElements = ['id_report', 'shift', 'date', 'handle'];
  searchText: string = '';
  previous: string;
  
  @HostListener('input') oninput() {
    this.searchItems();
  }
  
  constructor(private cdRef: ChangeDetectorRef, private router: Router, public authService: AuthService) {}

  async ngOnChanges(changes: SimpleChanges) {
    console.log("changes ", changes);

    if (this.stateModal) {
      console.log("MESSAGE STATEMODAL TRUE CHANGES");

      this.elements = this.data;
      this.mdbTable.setDataSource(this.elements);
      this.elements = this.mdbTable.getDataSource();
      this.previous = this.mdbTable.getDataSource();
      this.ngAfterViewInit();
      this.reponseStateModal.emit(false);
    }
  }

  ngOnInit() {

      this.elements = this.data;
      this.mdbTable.setDataSource(this.elements);
      this.elements = this.mdbTable.getDataSource();
      this.previous = this.mdbTable.getDataSource();
  }

  searchItems() {

    const prev = this.mdbTable.getDataSource();
    
    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.elements = this.mdbTable.getDataSource();
    }
    if (this.searchText) {
      this.elements = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(50);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  deleteObject( object: any ){
    
    this.reponseDeleteTable.emit(object);
  }

  updateObject(object: any){

    this.reponseUpdateTable.emit(object);
  }

}

